import React, { useContext } from 'react'
import { string } from 'prop-types'
import { SiteConfigContext } from '../SiteConfigProvider'

AuthorByline.propTypes = {
	type: string.isRequired,
}

export function AuthorByline({ type }) {
	const {
		siteConstants: { META_DATA },
	} = useContext(SiteConfigContext)
	const siteName = META_DATA.applicationName

	const getAuthorByline = (type) => {
		switch (type) {
			case 'Contributing Writer':
				return <>{siteName} Contributing Writer</>
			case 'Old BDC Member':
			case 'New BDC Member':
				return <>business.com Member</>
			case 'Staff':
				return <>{siteName} Staff</>
			case 'Sponsor':
			default:
				return null
		}
	}

	return getAuthorByline(type)
}
